import {useMemo} from 'react'
import type {LineChartProps, BaseLineChartProps} from '../types'
import {Chart} from '../Chart'
import {
  getDataWithDefaults,
  getTransformedPlotOptions,
  getXAxisOptionWithDefaults,
  getYAxisOptionsWithDefaults,
} from './shared'

export const BaseLineChart = <T extends 'line' | 'spline'>({
  type,
  options,
  series: data,
  marker,
  labels,
  ...rest
}: BaseLineChartProps<T>) => {
  const {xAxis, yAxis, plot} = options ?? {}
  const xyAxisOptionsTransformed = useMemo(() => getXAxisOptionWithDefaults(xAxis), [xAxis])
  const yAxisOptionsTransformed = useMemo(() => getYAxisOptionsWithDefaults(yAxis), [yAxis])
  const series = useMemo(() => getDataWithDefaults(data as Highcharts.SeriesOptionsType[], type), [data, type])
  const plotOptionsTransformed = useMemo(() => getTransformedPlotOptions(plot, marker, labels), [plot, marker, labels])

  return (
    <Chart
      type={type}
      xAxisOptions={xyAxisOptionsTransformed}
      yAxisOptions={yAxisOptionsTransformed}
      series={series as Highcharts.SeriesOptionsType[]}
      plotOptions={plotOptionsTransformed}
      {...rest}
    />
  )
}

export const LineChart = (props: LineChartProps) => {
  return <BaseLineChart {...props} type="line" />
}

try{ BaseLineChart.displayName ||= 'BaseLineChart' } catch {}
try{ LineChart.displayName ||= 'LineChart' } catch {}